import { React, useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SongListCriteriaList from './SongListCriteriaList';

export default function SongListListCriteria(props) {
    const [availableItems, setAvailableItems ] = 
        useState([]);
    const [includeItems, setIncludeItems ] = 
        useState([]);
    const [excludeItems, setExcludeItems ] =
        useState([]);

    return(
        <Row style={{ 'height': '44vh', 'max-height':'44vh'}}>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Available Lists</Card.Title>
                    <SongListCriteriaList items={availableItems}
                                        criteriaType='list'
                                        itemGroup='available' 
                                        itemCount={props.itemCount}/>
                    <Card.Footer className='text-muted'>Drag and drop other lists to use for selection criteria</Card.Footer>
                </Card>
            </Col>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Included Lists</Card.Title>
                    <SongListCriteriaList items={includeItems}
                                        criteriaType='list'
                                        itemGroup='include' 
                                        itemCount={props.itemCount}/>
                    <Card.Footer className='text-muted'>Songs in these lists will be included in the list</Card.Footer>
                </Card>
            </Col>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Excluded Lists</Card.Title>
                    <SongListCriteriaList items={excludeItems}
                                        criteriaType='list'
                                        itemGroup='exclude' 
                                        itemCount={props.itemCount}/>
                    <Card.Footer className='text-muted'>Songs in these lists will be excluded from the list</Card.Footer>
                </Card>
            </Col>
        </Row>
    )
}